// extracted by mini-css-extract-plugin
export default {"my-paginated":"Paginated_my-paginated__0y2wY","my-actualButton":"Paginated_my-actualButton__DmL-1"};